import { TheftRecoveryCardModel, BillingBreakdownCardModel, BillingTotalCardModel, AutomaticLocationTransferCardModel, BleObdsCardModel, SimOTACardModel } from './model';
import { TheftRecoveryCard, BillingBreakdownCard, BillingTotalCard, AutomaticLocationTransferCard, BleObdsCard, SimOTACard } from './viewer';
export default {
  install(molten) {
    molten.addPlugin('DashboardItem', {
      type: TheftRecoveryCardModel.TYPE,
      viewer: TheftRecoveryCard,
      model: TheftRecoveryCardModel,
      name: 'Theft Recovery Mode',
      icon: 'fa fa-vehicle',
      objectType: 'vehicle'
    });
    molten.addPlugin('DashboardItem', {
      type: BillingBreakdownCardModel.TYPE,
      viewer: BillingBreakdownCard,
      model: BillingBreakdownCardModel,
      name: 'Billing Breakdown',
      objectType: 'bill'
    });
    molten.addPlugin('DashboardItem', {
      type: BillingTotalCardModel.TYPE,
      viewer: BillingTotalCard,
      model: BillingTotalCardModel,
      name: 'Billing Total',
      objectType: 'bill'
    });
    molten.addPlugin('DashboardItem', {
      type: AutomaticLocationTransferCardModel.TYPE,
      viewer: AutomaticLocationTransferCard,
      model: AutomaticLocationTransferCardModel,
      name: 'Automatic Location Transfer',
      objectType: 'company'
    });
    molten.addPlugin('DashboardItem', {
      type: BleObdsCardModel.TYPE,
      viewer: BleObdsCard,
      model: BleObdsCardModel,
      name: 'BLE OBDs',
      objectType: 'location'
    });
    molten.addPlugin('DashboardItem', {
      type: SimOTACardModel.TYPE,
      viewer: SimOTACard,
      model: SimOTACardModel,
      name: 'SIM OTA',
      objectType: 'location'
    });
  }
};